import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

export interface EmailCotizacionAttachment {
  fileName: string;
  fileContent: string; // base64
  mimeType: string;
}

export interface EmailCotizacionRequest {
  to: string;
  cc: string;
  jsonParametros: string;
  attachments: EmailCotizacionAttachment[];
}

/**
 * Servicio para el envío de correos de cotización.
 * Endpoint: POST /cotizador/email/enviar
 *
 * Usado actualmente en el flujo de cotización colectiva (modal-enviar-cotizacion).
 * Puede ser reutilizado para otros flujos de envío de cotización.
 */
@Injectable({
  providedIn: 'root',
})
export class EmailCotizacionService {
  private readonly apiUrl = `${environment.HOST}${URL_MAP.API.EMAIL_COTIZACION}`;

  constructor(private http: HttpClient) {}

  enviarEmail(request: EmailCotizacionRequest): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.post(this.apiUrl, request, { headers });
  }
}
